module.exports = "/_next/static/images/TechnologiesTools-4c4410fc70e7ce5a327c151c8b7f1ed3.png.webp";